'use client';

import OptionsModelEntity from '@/components/Options/OptionsMode';
import samplesModel from '@/components/Samples/SamplesModel';
import samplesDiagnosticPopupModel from '@/components/Samples/SamplesDiagnosticPopup/SamplesDiagnosticPopupModel';
import { useEffect } from 'react';
import BottomLine from '../BottomLine';
import CoreScript from '../core_script';
import SheetEditorPopup from '../XmlEditorPopup';
import Debug from '../Debug/Debug';

import { useSampleSelection } from '@/hooks/useSampleSelection';
import { observer } from 'mobx-react';
import CountDown from '../CountDown';
import { safeGet } from '@/sharedTypes/browserUtils';
import SampleInfo from '../SampleInfo';
import { PiEyeClosedThin } from 'react-icons/pi';
import sheetEditorEntity from '@/entities/SheetEditor/SheetEditor';
import { DndContext } from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';
import SamplesTour from '../Tour/SamplesTour';
import MidiHelper from '../MidiHelper';
import { useManagerEntity } from '@/shared/managerHelpers';
import { useTour } from '@reactour/tour';
import MidiStatus from '../MidiStatus';
import Spinner from '../Spinner/Spinner';

function Home() {
  useSampleSelection();
  const managerEntity = useManagerEntity();
  const { setIsOpen } = useTour();

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const handleOutsideClick = (event: any) => {
    const optionsRef: any = OptionsModelEntity.optionsRef;
    const optionsBtnRef: any = OptionsModelEntity.optionsBtnRef;
    const samplesRef: any = samplesModel.ref;
    const samplesBtnRef: any = samplesModel.samplesModelBtn;
    const samplesWarningRef = samplesDiagnosticPopupModel.ref;

    let clickedOutside = true;

    const elementsToCheck = [
      optionsRef,
      samplesRef,
      samplesBtnRef,
      optionsBtnRef,
      samplesWarningRef,
    ];

    const { clientX, clientY } = event;

    for (const ref of elementsToCheck) {
      if (ref && ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const isInside =
          clientX >= rect.left &&
          clientX <= rect.right &&
          clientY >= rect.top &&
          clientY <= rect.bottom;

        if (isInside) {
          clickedOutside = false;
          break;
        }
      }
    }

    if (clickedOutside) {
      closeAllTabs();
    }
  };

  return (
    <div
      className='min-h-screen w-full flex flex-col'
      onKeyDown={(e) => {
        globalKeyPressed(e);
      }}
    >
      <DndContext
        onDragEnd={(event) => {
          if (event.active.id === 'popup' && event.delta) {
            sheetEditorEntity.updatePopupPosition(event.delta);
          }
        }}
        modifiers={[restrictToWindowEdges]}
      >
        <div className='flex-auto w-full flex flex-col items-center'>
          <SampleInfo />
          <CoreScript />
          <CountDown />
          <Debug />
          {sheetEditorEntity.noteEditingPopupVisible && <SheetEditorPopup />}
        </div>
        {safeGet('rendererSheetModel') && safeGet('rendererSheetModel.hidden') && (
          <div className='fixed inset-0 z-50 bg-background flex items-center justify-center pointer-events-none'>
            <PiEyeClosedThin size={256} />
          </div>
        )}
        <div className='hidden md:block'>
          <SamplesTour />
        </div>
      </DndContext>
      <Spinner></Spinner>
      <BottomLine />
      {/* <MidiHelper managerEntity={managerEntity} /> */}
      <MidiStatus />
    </div>
  );
  //   return (
  //     <div
  //       className='max-h-screen w-screen flex flex-col'
  //       onKeyDown={(e) => {
  //         globalKeyPressed(e);
  //       }}
  //     >
  //       <div className='flex-auto w-full overflow-y-auto'>
  //         <SampleInfo />
  //         {safeGet('rendererSheetModel') && (
  //           <div className='w-full flex items-center justify-center'>
  //             {safeGet('rendererSheetModel.hidden') && (
  //               <div className='fixed inset-0 z-50 bg-background flex items-center justify-center'>
  //                 <PiEyeClosedThin size={256} />
  //               </div>
  //             )}
  //           </div>
  //         )}
  //         <CoreScript />
  //         <CountDown />
  //         <Debug />
  //         <SheetEditorPopup />
  //       </div>
  //       <BottomLine />
  //     </div>
  //   );
}

function globalKeyPressed(e: any) {
  switch (e.key) {
    case 'Escape':
      closeAllTabs();
      break;
    default:
      break;
  }
}

function closeAllTabs() {
  OptionsModelEntity.showOptions = false;
  samplesModel.samplesHidden = true;
}

export default observer(Home);
